import { BasketService } from '../../../services/basket/BasketService';
import * as style from './style.css';
import { AccountService } from '../../../services/accountService/AccountService';
import LoginForm from '../../userAccount/login/LoginForm';
import Emitter from '../../../services/eventEmmiter/EventEmmiter';
import { EventTypes } from '../../../services/eventEmmiter/EventTypes';
import React = require('react');

interface IProps {
    basketService: BasketService;
}

interface IState {
    email: string;
    password: string;
}

export default class BasketLoginForm extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            email: '',
            password: ''
        };
    }

    accountService = AccountService.Instance();

    render() {
        return (< div className={style.userForm}>
            <LoginForm
                accountService={this.accountService}
                onSuccess={() => {
                    Emitter.emit(EventTypes.Shopping, null);
                } }
            />
        </div>

        );
    }
}
